import { createSlice } from "@reduxjs/toolkit";
import { apiGetOurWork, apiGetOurWorkDetail } from "../helpers/backend_helper";
import { fetchBlogFailure } from "./blogSlice";

const workSlice = createSlice({
  name: "work",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchOurWorkRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchOurWorkSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    fetchOurWorkFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchOurWorkRequest, fetchOurWorkSuccess, fetchOurWorkFailure } = workSlice.actions;

export const fetchOurWorkData = () => async (dispatch) => {
  dispatch(fetchOurWorkRequest());
  try {
    const response = await apiGetOurWork(); 
    dispatch(fetchOurWorkSuccess(response.results.data)); 
  } catch (error) {
    dispatch(fetchOurWorkFailure(error.message || "Failed to fetch career data."));
  }
};


export const fetchOurWorkDetailData = (id) => async(dispatch) => {
  dispatch(fetchOurWorkRequest());
  try{
    const response = await apiGetOurWorkDetail(id);
    dispatch(fetchOurWorkSuccess(response.results.data));
  }
  catch(error){
    dispatch(fetchBlogFailure(error.message || ' Failed to fetch Work details '));
  }
}

export default workSlice.reducer;
